class MobileMenuHeader {
  constructor({ el, btn, btns }) {
    this.el = el;
    this.body = document.querySelector('body');
    this.mobileMenuContainerItems = el.parentNode.querySelectorAll(
      '[data-mobile-menu-header-items]'
    );
    this.btn = btn;
    this.btns = btns;
    this.imagesLoaded = false;

    this.init();
  }

  init() {
    this.btn.addEventListener('click', (event) => {
      this.toggle(event);
    });
    this.btns.forEach((btn) => {
      btn.addEventListener('click', (event) => {
        this.toggleMenuItem(event);
      });
    });
    this.mobileMenuContainerItems.forEach((containerItems) => {
      const menuItems = containerItems.querySelectorAll(
        '[data-mobile-menu-header-item]'
      );
      menuItems.forEach((menuItem) => {
        const backBtn = menuItem.querySelector(
          '[data-mobile-menu-header-item-back]'
        );
        backBtn.addEventListener('click', (event) => {
          const menuItem = event.currentTarget.closest(
            '[data-mobile-menu-header-item]'
          );
          const menuItemBtn = menuItem.querySelector(
            '[data-mobile-menu-header-item-btn]'
          );
          if (menuItem) {
            menuItem.classList.remove('active');
          }
          if (menuItemBtn) {
            menuItemBtn.classList.remove('active');
          }
        });
      });
    });
  }

  toggle() {
    this.btn.classList.toggle('active');
    this.el.classList.toggle('active');
    this.body.classList.toggle('no-scroll');

    if (!this.imagesLoaded) {
      this.body
        .querySelectorAll('.mobile-menu-header-items img')
        .forEach((img) => {
          if (img.dataset.menuSrc) {
            img.setAttribute('src', img.dataset.menuSrc);
          }
        });
      this.imagesLoaded = true;
    }

    this.mobileMenuContainerItems.forEach((containerItems) => {
      const menuItems = containerItems.querySelectorAll(
        '[data-mobile-menu-header-item]'
      );
      menuItems.forEach((menuItem) => {
        menuItem.classList.remove('active');
      });
    });
  }

  toggleMenuItem(event) {
    const btn = event.currentTarget;
    this.mobileMenuContainerItems.forEach((containerItems) => {
      const menuItems = containerItems.querySelectorAll(
        '[data-mobile-menu-header-item]'
      );
      menuItems.forEach((menuItem) => {
        if (
          btn.dataset.mobileMenuHeaderItemBtn ===
          menuItem.dataset.mobileMenuHeaderItem
        ) {
          menuItem.classList.toggle('active');
        }
      });
    });
    btn.classList.toggle('active');
    this.body.querySelector('.header-menu').classList.toggle('active');
  }
}

export default MobileMenuHeader;
